import React from 'react'
import type { SVGProps } from 'react'

export default function Bottom(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={28}
      height={28}
      viewBox='0 0 1024 1024'
      {...props}
    >
      <path
        fill='currentColor'
        d='M544 805.888V168a32 32 0 1 0-64 0v637.888L246.656 557.952a30.72 30.72 0 0 0-45.312 0a35.52 35.52 0 0 0 0 48.064l288 306.048a30.72 30.72 0 0 0 45.312 0l288-306.048a35.52 35.52 0 0 0 0-48a30.72 30.72 0 0 0-45.312 0L544 805.824z'
        strokeWidth={25.5}
        stroke='currentColor'
      ></path>
    </svg>
  )
}
